import { render } from "./cycle-tab.vue?vue&type=template&id=a7b8cb7e&scoped=true"
import script from "./cycle-tab.vue?vue&type=script&lang=js"
export * from "./cycle-tab.vue?vue&type=script&lang=js"

import "./cycle-tab.vue?vue&type=style&index=0&id=a7b8cb7e&scoped=true&lang=css"

import exportComponent from "../../../../procollege/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a7b8cb7e"]])

export default __exports__